import classNames from "classnames"
import Form from "react-bootstrap/Form";
import { InputTextProps } from "../../../types/components/InputTextProps";

const InputText = ({ label, placeholder, info, isInputError, rest }: InputTextProps) => {
  return (
    <Form.Group className={classNames({ 'form-group': true, 'error': isInputError })}>
      {/* Input Label */}
      {label && <label>{label}</label>}

      {/* Input */}
      <Form.Control {...rest}
        placeholder={placeholder ? placeholder :
          label ? "Type your " + label.toLowerCase() :
            "Placeholder"
        }
      />

      {/* Input Information */}
      {info &&
        <span className={classNames({ 'info-password': true, 'error': isInputError })}>
          {info}
        </span>}
    </Form.Group>
  );
}

export default InputText;